import createSagaMiddleware from "redux-saga";
import { persistStore } from "redux-persist";
import { createStateSyncMiddleware, initMessageListener } from "redux-state-sync";
import { configureStore as configureAppStore } from "@reduxjs/toolkit";
import rootSaga from "../sagas/rootSaga";
import createPersistedRootReducer from "../reducers";

const configureStore = (initialState: any = {}) => {
  // root reducer with router state
  const rootReducer = createPersistedRootReducer();

  const config = {
    // REQUEST_IDVERIFICATION_TRANSACTION will not be triggered in other tabs
    blacklist: [
      "REQUEST_IDV_TRANSACTION",
      "ATHENA_APP_LOADING",
      "ATHENA_INIT_APP_SMS",
      "CREATE_TOAST",
    ],
  };

  const sagaMiddleware = createSagaMiddleware();
  const reduxSyncMiddleware = createStateSyncMiddleware(config);

  const middlewares = [sagaMiddleware, reduxSyncMiddleware];

  const store = configureAppStore({
    reducer: rootReducer,
    preloadedState: initialState,
    devTools: false,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
  });

  // initMessageListener(store);

  sagaMiddleware.run(rootSaga);

  const persistor = persistStore(store);
  if (location.pathname.indexOf("/login") !== -1) {
    persistor.purge();
  }

  return { store, persistor };
};

export default configureStore;
